import React from "react"
import ModalImage from "../modal-image";
import "./index.css"

export class SectionOurProjects extends React.Component {
	render() {
        const {projects} = this.props;
        return (
            <div className="projects">
                {
                    (projects || []).map((element, key) => (
                        <div className="project pure-g" key={key}>
                            <ModalImage imageQuerySelector={`#project_image_${key}`}/>
                            <div className="project-image pure-u-sm-1-1 pure-u-md-1-3">
                                <img id={`project_image_${key}`} alt={element.image_alt} src={element.image_url} />
                            </div>
                            <div className="project-body pure-u-sm-1-1 pure-u-md-2-3">
                                <h3 className="project-title">{element.title}</h3>
                                <h4 className="project-subtitle">{element.subtitle}</h4>
                                <div className="project-content" dangerouslySetInnerHTML={{__html:element.content}}/>
                            </div>
                        </div>
                    ))
                }
            </div>
        );
	}
}
